/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * Action type categories
 */
export enum ActivityActionType {
  LIKES = "LIKES",
  MESSAGES_CREATED = "MESSAGES_CREATED",
  READS = "READS",
}

/**
 * Time type categories
 */
export enum ActivityTimeframeType {
  SEVEN_DAYS = "SEVEN_DAYS",
  TWELVE_MONTHS = "TWELVE_MONTHS",
  TWENTYEIGHT_DAYS = "TWENTYEIGHT_DAYS",
}

/**
 * Filter the collection of leaders for the Query.
 */
export enum AllLeadersFilter {
  ALL = "ALL",
  CAN_MANAGE_DIRECT_AUDIENCE = "CAN_MANAGE_DIRECT_AUDIENCE",
  CAN_VIEW_DIRECT_AUDIENCE_MEMBERS = "CAN_VIEW_DIRECT_AUDIENCE_MEMBERS",
}

/**
 * The ordering to use for the threads in the all storyline feed
 */
export enum AllStorylineFeedThreadSortOrder {
  CREATED_AT = "CREATED_AT",
  UPDATED_AT = "UPDATED_AT",
}

/**
 * Enum for allowed file type, this is a backend uploading setting
 */
export enum AllowedUploadFileType {
  ALL = "ALL",
  MEDIA = "MEDIA",
  NONE = "NONE",
}

/**
 * Type of App Activity State
 */
export enum AppActivityState {
  ACTIVE_MOBILE = "ACTIVE_MOBILE",
  ACTIVE_WEB = "ACTIVE_WEB",
  IDLE_WEB = "IDLE_WEB",
}

/**
 * The ordering to use for the threads in a feed
 */
export enum AttachableLinkFeedThreadSortOrder {
  CREATED_AT = "CREATED_AT",
  UPDATED_AT = "UPDATED_AT",
}

/**
 * A filter for the suggested autocomplete group results
 */
export enum AutocompleteGroupResultFilter {
  VIEWER_CAN_START_THREAD = "VIEWER_CAN_START_THREAD",
}

/**
 * A filter for the suggested autocomplete group results
 */
export enum AutocompleteOfficeGroupResultFilter {
  ALL = "ALL",
  EXCLUDE_M365_GROUPS = "EXCLUDE_M365_GROUPS",
}

/**
 * Types of filters that can be used when querying for topics.
 */
export enum AutocompleteTopicResultFilter {
  ALL = "ALL",
  CURATED = "CURATED",
  CURATED_APPROVED = "CURATED_APPROVED",
  EXCLUDE_CURATED_APPROVED = "EXCLUDE_CURATED_APPROVED",
}

/**
 * A filter for the suggested autocomplete group results
 */
export enum AutocompleteUserResultFilter {
  EXCLUDE_EXTERNAL = "EXCLUDE_EXTERNAL",
  EXCLUDE_LEADERS = "EXCLUDE_LEADERS",
  ONLY_LEADERS = "ONLY_LEADERS",
}

/**
 * A filter for the suggested autocomplete user results
 */
export enum AutocompleteUserResultFilterType {
  EXCLUDE_FOREIGN_NETWORK_USERS = "EXCLUDE_FOREIGN_NETWORK_USERS",
  EXCLUDE_GUESTS = "EXCLUDE_GUESTS",
  EXCLUDE_LEADERS = "EXCLUDE_LEADERS",
  ONLY_LEADERS = "ONLY_LEADERS",
}

/**
 * The ordering to use for the threads in a feed
 */
export enum BookmarkFeedThreadSortOrder {
  UPDATED_AT = "UPDATED_AT",
}

/**
 * Type of Broadcast Activity State
 */
export enum BroadcastActivityState {
  NOT_WATCHING = "NOT_WATCHING",
  WATCHING = "WATCHING",
}

/**
 * Enum for the type of event. @deprecated(reason: 'This enum schema will be deprecated in favor of TeamsLiveEventType schema')
 */
export enum BroadcastEventType {
  TEAMS = "TEAMS",
  YAMMER_BYOE = "YAMMER_BYOE",
  YAMMER_GOLIVE = "YAMMER_GOLIVE",
  YAMMER_QUICKSTART = "YAMMER_QUICKSTART",
}

/**
 * The ordering to use for the threads in a feed
 */
export enum BroadcastFeedThreadSortOrder {
  CREATED_AT = "CREATED_AT",
  CREATED_OR_PUBLISHED_AT = "CREATED_OR_PUBLISHED_AT",
  UPDATED_AT = "UPDATED_AT",
}

/**
 * Types of broadcast feeds.
 */
export enum BroadcastFeedType {
  ALL = "ALL",
  MODERATION_DISMISSED = "MODERATION_DISMISSED",
  MODERATION_PENDING = "MODERATION_PENDING",
  MODERATION_PENDING_QUESTIONS = "MODERATION_PENDING_QUESTIONS",
  QUESTIONS = "QUESTIONS",
  UNANSWERED_QUESTIONS = "UNANSWERED_QUESTIONS",
  VIEWER_IS_THREAD_STARTER_SENDER = "VIEWER_IS_THREAD_STARTER_SENDER",
}

/**
 * The status of the broadcast.
 */
export enum BroadcastStatus {
  CREATED = "CREATED",
  ENDED = "ENDED",
  STARTED = "STARTED",
}

/**
 * Types of metrics based on the activity related to a campaign.
 */
export enum CampaignActivityActionType {
  LEADERS_WITH_THREAD_STARTERS = "LEADERS_WITH_THREAD_STARTERS",
  LEADERS_WITH_THREAD_STARTER_REACTIONS = "LEADERS_WITH_THREAD_STARTER_REACTIONS",
  LEADERS_WITH_THREAD_STARTER_REPLIES = "LEADERS_WITH_THREAD_STARTER_REPLIES",
  LEADERS_WITH_THREAD_STARTER_VIEWS = "LEADERS_WITH_THREAD_STARTER_VIEWS",
  LEADERS_WITH_VISITS = "LEADERS_WITH_VISITS",
  LEADER_FOLLOWERS = "LEADER_FOLLOWERS",
  LEADER_FOLLOWERS_WITH_THREAD_STARTERS = "LEADER_FOLLOWERS_WITH_THREAD_STARTERS",
  LEADER_FOLLOWERS_WITH_THREAD_STARTER_REACTIONS = "LEADER_FOLLOWERS_WITH_THREAD_STARTER_REACTIONS",
  LEADER_FOLLOWERS_WITH_THREAD_STARTER_REPLIES = "LEADER_FOLLOWERS_WITH_THREAD_STARTER_REPLIES",
  LEADER_FOLLOWERS_WITH_THREAD_STARTER_VIEWS = "LEADER_FOLLOWERS_WITH_THREAD_STARTER_VIEWS",
  LEADER_FOLLOWERS_WITH_VISITS = "LEADER_FOLLOWERS_WITH_VISITS",
  TOTAL_CELEBRATE_REACTIONS = "TOTAL_CELEBRATE_REACTIONS",
  TOTAL_ENGAGED_USERS = "TOTAL_ENGAGED_USERS",
  TOTAL_FOLLOWERS = "TOTAL_FOLLOWERS",
  TOTAL_FOLLOWERS_WITH_THREAD_STARTERS = "TOTAL_FOLLOWERS_WITH_THREAD_STARTERS",
  TOTAL_FOLLOWERS_WITH_THREAD_STARTER_REACTIONS = "TOTAL_FOLLOWERS_WITH_THREAD_STARTER_REACTIONS",
  TOTAL_FOLLOWERS_WITH_THREAD_STARTER_REPLIES = "TOTAL_FOLLOWERS_WITH_THREAD_STARTER_REPLIES",
  TOTAL_FOLLOWERS_WITH_THREAD_STARTER_VIEWS = "TOTAL_FOLLOWERS_WITH_THREAD_STARTER_VIEWS",
  TOTAL_FOLLOWERS_WITH_VISITS = "TOTAL_FOLLOWERS_WITH_VISITS",
  TOTAL_GROUP_THREAD_STARTERS = "TOTAL_GROUP_THREAD_STARTERS",
  TOTAL_LAUGH_REACTIONS = "TOTAL_LAUGH_REACTIONS",
  TOTAL_LIKE_REACTIONS = "TOTAL_LIKE_REACTIONS",
  TOTAL_LOVE_REACTIONS = "TOTAL_LOVE_REACTIONS",
  TOTAL_REACTIONS = "TOTAL_REACTIONS",
  TOTAL_SAD_REACTIONS = "TOTAL_SAD_REACTIONS",
  TOTAL_STORYLINE_THREAD_STARTERS = "TOTAL_STORYLINE_THREAD_STARTERS",
  TOTAL_THANK_REACTIONS = "TOTAL_THANK_REACTIONS",
  TOTAL_THREAD_STARTERS = "TOTAL_THREAD_STARTERS",
  USERS_WITH_REACTION = "USERS_WITH_REACTION",
  USERS_WITH_REPLY = "USERS_WITH_REPLY",
  USERS_WITH_THREAD_STARTER = "USERS_WITH_THREAD_STARTER",
}

/**
 * Timeframe type categories for campaign activity.
 */
export enum CampaignActivityTimeframeType {
  ALL_TIME = "ALL_TIME",
  NINETY_DAYS = "NINETY_DAYS",
  SEVEN_DAYS = "SEVEN_DAYS",
  TWELVE_MONTHS = "TWELVE_MONTHS",
  TWENTY_EIGHT_DAYS = "TWENTY_EIGHT_DAYS",
}

/**
 * Available colors for campaigns.
 */
export enum CampaignColor {
  BLUE = "BLUE",
  GREEN = "GREEN",
  MAGENTA = "MAGENTA",
  ORANGE = "ORANGE",
  PURPLE = "PURPLE",
  RED = "RED",
  TEAL = "TEAL",
}

/**
 * Campaign Default threadStarter type
 */
export enum CampaignDefaultThreadStarterContentType {
  NORMAL = "NORMAL",
  POLL = "POLL",
  PRAISE = "PRAISE",
  QUESTION = "QUESTION",
}

/**
 * The ordering to use for the threads in a feed
 */
export enum CampaignFeedThreadSortOrder {
  CREATED_AT = "CREATED_AT",
  UPDATED_AT = "UPDATED_AT",
}

/**
 * Types of campaign feeds.
 */
export enum CampaignFeedType {
  ALL = "ALL",
  UNSEEN = "UNSEEN",
}

/**
 * The type of time unit for a time goal tracker type
 */
export enum CampaignGoalTrackerTimeUnitType {
  HOURS = "HOURS",
  MINUTES = "MINUTES",
}

/**
 * All the unit type of a campaign goal tracker
 */
export enum CampaignGoalTrackerType {
  CURRENCY = "CURRENCY",
  CUSTOM = "CUSTOM",
  TIME = "TIME",
}

/**
 * Sort order for campaigns
 */
export enum CampaignSortOrder {
  CREATION_DATE_DESC = "CREATION_DATE_DESC",
  FOLLOWER_COUNT_DESC = "FOLLOWER_COUNT_DESC",
  NAME_ASC = "NAME_ASC",
}

/**
 * The states a campaign can be in
 */
export enum CampaignState {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
}

/**
 * Filter for campaign states
 */
export enum CampaignStateFilter {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  DEFAULT = "DEFAULT",
  DRAFT = "DRAFT",
}

/**
 * Returns the users filtered by the type of the user. 
 */
export enum CampaignTopThreadStarterSenderFilter {
  EXCLUDE_LEADERS = "EXCLUDE_LEADERS",
  ONLY_LEADERS = "ONLY_LEADERS",
}

/**
 * Conversation theme type at the viewer leader level.
 */
export enum ConversationThemeType {
  POPULAR_THEMES = "POPULAR_THEMES",
  TRENDING_THEMES = "TRENDING_THEMES",
}

/**
 * Available convertable object types to convert from a legacy id to/from a GraphQL id.
 */
export enum ConvertibleObjectType {
  BROADCAST = "BROADCAST",
  CAMPAIGN = "CAMPAIGN",
  GROUP = "GROUP",
  MESSAGE = "MESSAGE",
  TEAMS_MEETING = "TEAMS_MEETING",
  TEAMS_MEETING_INSTANCE = "TEAMS_MEETING_INSTANCE",
  THREAD = "THREAD",
  TOPIC = "TOPIC",
  USER = "USER",
}

/**
 * Types of filters that can be used when quering for curated topics.
 */
export enum CuratedTopicsFilter {
  CURATED_APPROVED = "CURATED_APPROVED",
  CURATED_PROPOSED = "CURATED_PROPOSED",
  DEFAULT = "DEFAULT",
}

/**
 * Types of filters that can be used when quering current user groups.
 */
export enum CurrentUserGroupFilter {
  EXCLUDE_PENDING = "EXCLUDE_PENDING",
  VIEWER_IS_ADMIN = "VIEWER_IS_ADMIN",
}

/**
 * Delegate role type in a DelegateTeam
 */
export enum DelegateRole {
  CONTENT_CONTRIBUTOR = "CONTENT_CONTRIBUTOR",
  DELEGATE_MANAGER = "DELEGATE_MANAGER",
}

/**
 * Status of triggering asynchronous task to add all users in an office group as leaders
 */
export enum DesignateLeadersAsyncStartStatus {
  CREATED = "CREATED",
  TOO_MANY_TASKS_TRIGGERED = "TOO_MANY_TASKS_TRIGGERED",
}

/**
 * Determine the hidden status of a group
 */
export enum DiscoveryHiddenState {
  HIDDEN = "HIDDEN",
  NOT_HIDDEN = "NOT_HIDDEN",
  NOT_RETRIEVED = "NOT_RETRIEVED",
}

/**
 * Dismissable prompt types.
 */
export enum DismissablePromptType {
  LIVE_SITE_ISSUE = "LIVE_SITE_ISSUE",
}

/**
 * Activity status categories for groups in the org level leadership insights dashboard.
 */
export enum EmployeesTopGroupActivityStatus {
  ACTIVE = "ACTIVE",
  IDLE = "IDLE",
}

/**
 * Viewer leader and employees thread collection type.
 */
export enum EmployeesTopThreadType {
  EMPLOYEES_MOST_ENGAGED_FROM_LEADER_GROUP_THREADS = "EMPLOYEES_MOST_ENGAGED_FROM_LEADER_GROUP_THREADS",
  EMPLOYEES_MOST_ENGAGED_THREADS = "EMPLOYEES_MOST_ENGAGED_THREADS",
  EMPLOYEES_MOST_REACTED_THREADS = "EMPLOYEES_MOST_REACTED_THREADS",
  EMPLOYEES_MOST_REPLIED_THREADS = "EMPLOYEES_MOST_REPLIED_THREADS",
  EMPLOYEES_MOST_SHARED_THREADS = "EMPLOYEES_MOST_SHARED_THREADS",
  EMPLOYEES_MOST_VIEWED_THREADS = "EMPLOYEES_MOST_VIEWED_THREADS",
}

/**
 * The state representing whether a network allows users to participate in groups or conversations with users of other networks
 */
export enum ExternalMessagingState {
  ALLOW_ALL = "ALLOW_ALL",
  ALLOW_PARTICIPATION_IN_FOREIGN_NETWORK = "ALLOW_PARTICIPATION_IN_FOREIGN_NETWORK",
  DISABLED = "DISABLED",
}

/**
 * The state of the file
 */
export enum FileState {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  INACCESSIBLE = "INACCESSIBLE",
}

/**
 * The ordering to use for sorting followed by users
 */
export enum FollowedByUsersSortOrder {
  FOLLOWERS_DESC = "FOLLOWERS_DESC",
  NAME_ASC = "NAME_ASC",
}

/**
 * The ordering to use for the threads in a followed storylines feed
 */
export enum FollowedStorylineFeedThreadSortOrder {
  CREATED_AT = "CREATED_AT",
  UPDATED_AT = "UPDATED_AT",
}

/**
 * Types of filters that can be used when quering for topics followed by user.
 */
export enum FollowedTopicsFilter {
  ALL = "ALL",
  ONLY_CURATED = "ONLY_CURATED",
}

/**
 * The ordering to use for sorting followed users
 */
export enum FollowedUsersSortOrder {
  FOLLOWERS_DESC = "FOLLOWERS_DESC",
  NAME_ASC = "NAME_ASC",
}

/**
 * Group categories
 */
export enum GroupCategory {
  COMMUNITY = "COMMUNITY",
  NONE = "NONE",
  OTHER = "OTHER",
  PROJECT = "PROJECT",
  TEAM = "TEAM",
}

/**
 * The ordering to use for the threads in a feed
 */
export enum GroupFeedThreadSortOrder {
  CREATED_AT = "CREATED_AT",
  RECOMMENDED = "RECOMMENDED",
  UPDATED_AT = "UPDATED_AT",
}

/**
 * Types of group feeds.
 */
export enum GroupFeedType {
  ALL = "ALL",
  QUESTIONS = "QUESTIONS",
  RECOMMENDED = "RECOMMENDED",
  UNANSWERED_QUESTIONS = "UNANSWERED_QUESTIONS",
  UNSEEN = "UNSEEN",
}

/**
 * User membership status in the group
 */
export enum GroupMembershipStatus {
  INVITED = "INVITED",
  JOINED = "JOINED",
  NONE = "NONE",
  PENDING = "PENDING",
}

/**
 * Privacy levels for a group.
 */
export enum GroupPrivacy {
  MODERATED = "MODERATED",
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC",
}

/**
 * Privacy level enforcement for a group.
 */
export enum GroupPrivacyEnforcement {
  ENFORCE_PRIVATE = "ENFORCE_PRIVATE",
  ENFORCE_PUBLIC = "ENFORCE_PUBLIC",
  NONE = "NONE",
}

/**
 * Sort order for groups
 */
export enum GroupSortOrder {
  CREATION_DATE_DESC = "CREATION_DATE_DESC",
  MEMBER_COUNT_DESC = "MEMBER_COUNT_DESC",
  NAME_ASC = "NAME_ASC",
}

/**
 * The states a group can be in
 */
export enum GroupState {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  INACCESSIBLE = "INACCESSIBLE",
}

/**
 * Different ranking algorithms for sorting group suggestions
 */
export enum GroupSuggestionRank {
  DISCOVERY_RANK = "DISCOVERY_RANK",
  LEGACY_PROXIMITY_RANK = "LEGACY_PROXIMITY_RANK",
  LEGACY_USER_RANK = "LEGACY_USER_RANK",
}

/**
 * Group suggestion surface type
 */
export enum GroupSuggestionSurface {
  ANDROID_DISCOVER_GROUPS = "ANDROID_DISCOVER_GROUPS",
  ANDROID_GROUP_LIST = "ANDROID_GROUP_LIST",
  IOS_DISCOVER_GROUPS = "IOS_DISCOVER_GROUPS",
  IOS_GROUP_LIST = "IOS_GROUP_LIST",
  WEB_DISCOVER_GROUPS = "WEB_DISCOVER_GROUPS",
  WEB_FIRST_RUN = "WEB_FIRST_RUN",
  WEB_LIGHTBOX = "WEB_LIGHTBOX",
  WEB_RIGHT_RAIL_HOME = "WEB_RIGHT_RAIL_HOME",
  WEB_RIGHT_RAIL_USER = "WEB_RIGHT_RAIL_USER",
}

/**
 * The ordering to use for the threads in a feed
 */
export enum HomeFeedCardThreadSortOrder {
  DISCOVERY = "DISCOVERY",
  UPDATED_AT = "UPDATED_AT",
}

/**
 * Possible feed types content can be loaded from
 */
export enum HomeFeedType {
  ALL_PUBLIC_GROUPS = "ALL_PUBLIC_GROUPS",
  DISCOVERY = "DISCOVERY",
  DISCOVERY_LEADERS = "DISCOVERY_LEADERS",
  FOLLOWING_AND_ALLCOMPANY = "FOLLOWING_AND_ALLCOMPANY",
  LEGACY_DISCOVERY = "LEGACY_DISCOVERY",
}

/**
 * The ordering to use for the threads in a Moments feed.
 */
export enum HomeMomentsFeedThreadSortOrder {
  DISCOVERY = "DISCOVERY",
}

/**
 * Possible feed types for loading the moments feed.
 */
export enum HomeMomentsFeedType {
  DEFAULT = "DEFAULT",
  LIMIT_ONE_PER_LEADER = "LIMIT_ONE_PER_LEADER",
  LIMIT_ONE_PER_USER = "LIMIT_ONE_PER_USER",
}

/**
 * The ordering to use for the threads in a feed
 */
export enum InboxFeedDraftThreadSortOrder {
  CREATED_AT = "CREATED_AT",
}

/**
 * The types of feeds that can be returned from an inbox.
 */
export enum InboxFeedType {
  ALL = "ALL",
  DIRECT = "DIRECT",
  UNREAD = "UNREAD",
}

/**
 * The ordering to use for the threads in a feed
 */
export enum InboxThreadSortOrder {
  UPDATED_AT = "UPDATED_AT",
}

/**
 * Enum for the protocol of the ingest url
 */
export enum IngestProtocol {
  HTTP = "HTTP",
  HTTPS = "HTTPS",
  RTMP = "RTMP",
  RTMPS = "RTMPS",
}

/**
 * Enum for the type ol the ingest url
 */
export enum IngestType {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
}

/**
 * Leader group suggestion surface type
 */
export enum LeaderGroupSuggestionSurface {
  WEB_RIGHT_RAIL_HOME = "WEB_RIGHT_RAIL_HOME",
}

/**
 * Types of personal or org level metrics based on the activity of a leader or users in a leader's org.
 */
export enum LeadershipActivityActionType {
  EMPLOYEES_ACTIVE_CONNECTIONS_FORMED = "EMPLOYEES_ACTIVE_CONNECTIONS_FORMED",
  EMPLOYEES_CONNECTIONS_FORMED = "EMPLOYEES_CONNECTIONS_FORMED",
  EMPLOYEES_PASSIVE_CONNECTIONS_FORMED = "EMPLOYEES_PASSIVE_CONNECTIONS_FORMED",
  EMPLOYEES_PERCENTAGE_ENGAGED = "EMPLOYEES_PERCENTAGE_ENGAGED",
  EMPLOYEES_PERCENTAGE_REPLIED_TO = "EMPLOYEES_PERCENTAGE_REPLIED_TO",
  EMPLOYEES_TOTAL_NORMAL_THREAD_STARTERS = "EMPLOYEES_TOTAL_NORMAL_THREAD_STARTERS",
  EMPLOYEES_TOTAL_POLL_THREAD_STARTERS = "EMPLOYEES_TOTAL_POLL_THREAD_STARTERS",
  EMPLOYEES_TOTAL_PRAISE_THREAD_STARTERS = "EMPLOYEES_TOTAL_PRAISE_THREAD_STARTERS",
  EMPLOYEES_TOTAL_QUESTION_THREAD_STARTERS = "EMPLOYEES_TOTAL_QUESTION_THREAD_STARTERS",
  EMPLOYEES_TOTAL_THREAD_STARTERS = "EMPLOYEES_TOTAL_THREAD_STARTERS",
  EMPLOYEES_VIEWED_ANNOUNCEMENT = "EMPLOYEES_VIEWED_ANNOUNCEMENT",
  EMPLOYEES_VIEWED_GROUP_MESSAGE = "EMPLOYEES_VIEWED_GROUP_MESSAGE",
  EMPLOYEES_VIEWED_STORYLINE_MESSAGE = "EMPLOYEES_VIEWED_STORYLINE_MESSAGE",
  EMPLOYEES_WITH_QUESTION_THREAD_STARTER = "EMPLOYEES_WITH_QUESTION_THREAD_STARTER",
  EMPLOYEES_WITH_REACTION = "EMPLOYEES_WITH_REACTION",
  EMPLOYEES_WITH_REPLY = "EMPLOYEES_WITH_REPLY",
  EMPLOYEES_WITH_THREAD_STARTER = "EMPLOYEES_WITH_THREAD_STARTER",
  EMPLOYEES_WITH_VIEW = "EMPLOYEES_WITH_VIEW",
  VIEWER_ACTIVE_CONNECTIONS_FORMED = "VIEWER_ACTIVE_CONNECTIONS_FORMED",
  VIEWER_AVERAGE_REPLIES_PER_THREAD_STARTER = "VIEWER_AVERAGE_REPLIES_PER_THREAD_STARTER",
  VIEWER_ENGAGED_FOLLOWERS_PERCENTAGE = "VIEWER_ENGAGED_FOLLOWERS_PERCENTAGE",
  VIEWER_ENGAGED_THREAD_VIEWERS_PERCENTAGE = "VIEWER_ENGAGED_THREAD_VIEWERS_PERCENTAGE",
  VIEWER_PASSIVE_CONNECTIONS_FORMED = "VIEWER_PASSIVE_CONNECTIONS_FORMED",
  VIEWER_TOTAL_CELEBRATE_REACTIONS = "VIEWER_TOTAL_CELEBRATE_REACTIONS",
  VIEWER_TOTAL_FOLLOWERS = "VIEWER_TOTAL_FOLLOWERS",
  VIEWER_TOTAL_FOLLOWING = "VIEWER_TOTAL_FOLLOWING",
  VIEWER_TOTAL_LAUGH_REACTIONS = "VIEWER_TOTAL_LAUGH_REACTIONS",
  VIEWER_TOTAL_LIKE_REACTIONS = "VIEWER_TOTAL_LIKE_REACTIONS",
  VIEWER_TOTAL_LOVE_REACTIONS = "VIEWER_TOTAL_LOVE_REACTIONS",
  VIEWER_TOTAL_REACTIONS = "VIEWER_TOTAL_REACTIONS",
  VIEWER_TOTAL_REPLIES_ON_VIEWER_THREAD_STARTERS = "VIEWER_TOTAL_REPLIES_ON_VIEWER_THREAD_STARTERS",
  VIEWER_TOTAL_SAD_REACTIONS = "VIEWER_TOTAL_SAD_REACTIONS",
  VIEWER_TOTAL_THANK_REACTIONS = "VIEWER_TOTAL_THANK_REACTIONS",
}

/**
 * Time type categories for viewer leader and employee activity.
 */
export enum LeadershipActivityTimeframeType {
  NINETY_DAYS = "NINETY_DAYS",
  SEVEN_DAYS = "SEVEN_DAYS",
  THIRTY_DAYS = "THIRTY_DAYS",
  TWELVE_MONTHS = "TWELVE_MONTHS",
  TWENTY_EIGHT_DAYS = "TWENTY_EIGHT_DAYS",
}

/**
 * Thread type categories for the personal level viewer leader insights dashboard.
 * @deprecated(reason: 'Use ViewerActivityThreadType instead.')
 */
export enum LeadershipActivityViewerThreadType {
  ALL = "ALL",
  STORIES_AND_STORYLINE = "STORIES_AND_STORYLINE",
}

/**
 * Message Content Type
 */
export enum MessageContentType {
  NORMAL = "NORMAL",
  QUESTION = "QUESTION",
}

/**
 * Specifies the outcome of deleting a message, indicating to a client how the UI can be updated
 */
export enum MessageDeletionOutcome {
  MESSAGE_AND_PARENT_REMOVED = "MESSAGE_AND_PARENT_REMOVED",
  MESSAGE_PLACEHOLDER_RETAINED = "MESSAGE_PLACEHOLDER_RETAINED",
  MESSAGE_REMOVED = "MESSAGE_REMOVED",
  THREAD_REMOVED = "THREAD_REMOVED",
}

/**
 * Moderation states for Message.
 */
export enum MessageModerationState {
  DISMISSED = "DISMISSED",
  PENDING = "PENDING",
}

/**
 * Supported badges for user to show on the message threads.
 */
export enum MessageSenderBadge {
  ADMIN = "ADMIN",
  FIRST_THREAD = "FIRST_THREAD",
  TOP_CONTRIBUTOR = "TOP_CONTRIBUTOR",
}

/**
 * Month type categories
 */
export enum MonthType {
  APR = "APR",
  AUG = "AUG",
  DEC = "DEC",
  FEB = "FEB",
  JAN = "JAN",
  JUL = "JUL",
  JUN = "JUN",
  MAR = "MAR",
  MAY = "MAY",
  NOV = "NOV",
  OCT = "OCT",
  SEP = "SEP",
}

/**
 * Types of my leaders feed.
 */
export enum MyLeadersFeedType {
  ALL = "ALL",
  ANNOUNCEMENTS = "ANNOUNCEMENTS",
  UNSEEN = "UNSEEN",
}

/**
 * Filter the collection leaders for the viewer. Leaders for viewer can be from other org beyond my leaders.
 */
export enum MyLeadersFilter {
  CONNECTED_LEADERS = "CONNECTED_LEADERS",
  CONNECTED_LEADERS_AND_FOLLOWED_LEADERS = "CONNECTED_LEADERS_AND_FOLLOWED_LEADERS",
  FOLLOWED_LEADERS = "FOLLOWED_LEADERS",
}

/**
 * The ordering to use for sorting MyLeaders
 */
export enum MyLeadersSortOrder {
  AUDIENCE_COUNT_DESCENDING = "AUDIENCE_COUNT_DESCENDING",
}

/**
 * Filter the collection of network question achievements
 */
export enum NetworkQuestionAchievementFilter {
  ALL = "ALL",
  ONLY_EARNED_ACHIEVEMENTS = "ONLY_EARNED_ACHIEVEMENTS",
}

/**
 * The ordering to use for sorting network question achievements
 */
export enum NetworkQuestionAchievementSortOrder {
  DEFAULT = "DEFAULT",
  UPDATED_AT = "UPDATED_AT",
}

/**
 * Network and Viewer level metrics for network question activity.
 */
export enum NetworkQuestionActivityActionType {
  NETWORK_ACTIVE_USERS = "NETWORK_ACTIVE_USERS",
  NETWORK_ANSWER_PER_QUESTION = "NETWORK_ANSWER_PER_QUESTION",
  NETWORK_BEST_REPLY_MARKED = "NETWORK_BEST_REPLY_MARKED",
  NETWORK_BEST_REPLY_ON_QUESTION_THREAD_STARTER = "NETWORK_BEST_REPLY_ON_QUESTION_THREAD_STARTER",
  NETWORK_COST_SAVED = "NETWORK_COST_SAVED",
  NETWORK_FIRST_LEVEL_REPLY_TO_QUESTION_THREAD_STARTER = "NETWORK_FIRST_LEVEL_REPLY_TO_QUESTION_THREAD_STARTER",
  NETWORK_FIRST_REPLY_ON_QUESTION_THREAD_STARTER = "NETWORK_FIRST_REPLY_ON_QUESTION_THREAD_STARTER",
  NETWORK_PAGE_VISITS = "NETWORK_PAGE_VISITS",
  NETWORK_PASSIVE_USERS = "NETWORK_PASSIVE_USERS",
  NETWORK_QUESTION_THREAD_STARTER_POSTED = "NETWORK_QUESTION_THREAD_STARTER_POSTED",
  NETWORK_QUESTION_THREAD_STARTER_POSTED_PER_USER = "NETWORK_QUESTION_THREAD_STARTER_POSTED_PER_USER",
  NETWORK_TIME_SAVED = "NETWORK_TIME_SAVED",
  NETWORK_TIME_TO_BEST_ANSWER = "NETWORK_TIME_TO_BEST_ANSWER",
  NETWORK_TIME_TO_FIRST_ANSWER = "NETWORK_TIME_TO_FIRST_ANSWER",
  NETWORK_TOTAL_UP_VOTES_ON_ANSWERS = "NETWORK_TOTAL_UP_VOTES_ON_ANSWERS",
  NETWORK_TOTAL_USERS = "NETWORK_TOTAL_USERS",
  NETWORK_VIEWS_ON_QUESTION_THREAD_STARTERS_PER_USER = "NETWORK_VIEWS_ON_QUESTION_THREAD_STARTERS_PER_USER",
  NETWORK_VIEWS_PER_QUESTION_THREAD_STARTER = "NETWORK_VIEWS_PER_QUESTION_THREAD_STARTER",
  VIEWER_BEST_REPLY_MARKED = "VIEWER_BEST_REPLY_MARKED",
  VIEWER_FIRST_LEVEL_REPLY_TO_QUESTION_THREAD_STARTER = "VIEWER_FIRST_LEVEL_REPLY_TO_QUESTION_THREAD_STARTER",
  VIEWER_IMPACT_RANKING = "VIEWER_IMPACT_RANKING",
  VIEWER_QUESTION_THREAD_STARTER_POSTED = "VIEWER_QUESTION_THREAD_STARTER_POSTED",
  VIEWER_TIME_SAVED = "VIEWER_TIME_SAVED",
  VIEWER_TOTAL_CELEBRATE_REACTIONS_ON_ANSWERS = "VIEWER_TOTAL_CELEBRATE_REACTIONS_ON_ANSWERS",
  VIEWER_TOTAL_LAUGH_REACTIONS_ON_ANSWERS = "VIEWER_TOTAL_LAUGH_REACTIONS_ON_ANSWERS",
  VIEWER_TOTAL_LIKE_REACTIONS_ON_ANSWERS = "VIEWER_TOTAL_LIKE_REACTIONS_ON_ANSWERS",
  VIEWER_TOTAL_LOVE_REACTIONS_ON_ANSWERS = "VIEWER_TOTAL_LOVE_REACTIONS_ON_ANSWERS",
  VIEWER_TOTAL_REACTIONS_ON_ANSWERS = "VIEWER_TOTAL_REACTIONS_ON_ANSWERS",
  VIEWER_TOTAL_SAD_REACTIONS_ON_ANSWERS = "VIEWER_TOTAL_SAD_REACTIONS_ON_ANSWERS",
  VIEWER_TOTAL_THANK_REACTIONS_ON_ANSWERS = "VIEWER_TOTAL_THANK_REACTIONS_ON_ANSWERS",
  VIEWER_TOTAL_UP_VOTES_ON_ANSWERS = "VIEWER_TOTAL_UP_VOTES_ON_ANSWERS",
  VIEWER_VIEWS_ON_QUESTION_THREAD_STARTER = "VIEWER_VIEWS_ON_QUESTION_THREAD_STARTER",
}

/**
 * Engagement type categories for the question thread starter posted by the viewer.
 */
export enum NetworkQuestionActivityThreadType {
  NETWORK_QUESTION_THREAD_STARTER_WITH_MOST_ANSWERS = "NETWORK_QUESTION_THREAD_STARTER_WITH_MOST_ANSWERS",
  NETWORK_QUESTION_THREAD_STARTER_WITH_MOST_PEOPLE_HELPED = "NETWORK_QUESTION_THREAD_STARTER_WITH_MOST_PEOPLE_HELPED",
  NETWORK_QUESTION_THREAD_STARTER_WITH_MOST_REACTIONS = "NETWORK_QUESTION_THREAD_STARTER_WITH_MOST_REACTIONS",
  NETWORK_QUESTION_THREAD_STARTER_WITH_MOST_TIME_SAVED = "NETWORK_QUESTION_THREAD_STARTER_WITH_MOST_TIME_SAVED",
  NETWORK_QUESTION_THREAD_STARTER_WITH_MOST_VIEWS = "NETWORK_QUESTION_THREAD_STARTER_WITH_MOST_VIEWS",
  NETWORK_QUESTION_THREAD_STARTER_WITH_MOST_VOTES = "NETWORK_QUESTION_THREAD_STARTER_WITH_MOST_VOTES",
  VIEWER_FIRST_LEVEL_REPLY_TO_QUESTION_THREAD_STARTER = "VIEWER_FIRST_LEVEL_REPLY_TO_QUESTION_THREAD_STARTER",
  VIEWER_MENTIONED_IN_QUESTION_THREAD_STARTER = "VIEWER_MENTIONED_IN_QUESTION_THREAD_STARTER",
  VIEWER_QUESTION_THREAD_STARTER_POSTED = "VIEWER_QUESTION_THREAD_STARTER_POSTED",
}

/**
 * Time type categories for network question activity.
 */
export enum NetworkQuestionActivityTimeframeType {
  NINETY_DAYS = "NINETY_DAYS",
  SEVEN_DAYS = "SEVEN_DAYS",
  THIRTY_DAYS = "THIRTY_DAYS",
  TWELVE_MONTHS = "TWELVE_MONTHS",
  TWENTY_EIGHT_DAYS = "TWENTY_EIGHT_DAYS",
}

/**
 * The ordering to use for the threads in a network question feed
 */
export enum NetworkQuestionFeedThreadSortOrder {
  CREATED_AT = "CREATED_AT",
  UPDATED_AT = "UPDATED_AT",
  UPVOTE_RANK_THEN_CREATED_AT = "UPVOTE_RANK_THEN_CREATED_AT",
}

/**
 * Types of network question feeds.
 */
export enum NetworkQuestionFeedType {
  ALL = "ALL",
  UNANSWERED = "UNANSWERED",
  UNSEEN = "UNSEEN",
}

/**
 * The types of feeds that can be returned from a network question inbox.
 */
export enum NetworkQuestionInboxFeedType {
  ALL = "ALL",
  UNREAD = "UNREAD",
  VIEWER_IS_THREAD_STARTER_SENDER = "VIEWER_IS_THREAD_STARTER_SENDER",
}

/**
 * The ordering to use for the threads in a feed
 */
export enum NetworkQuestionInboxThreadSortOrder {
  UPDATED_AT = "UPDATED_AT",
}

/**
 * Type of a network question leveled achievement.
 */
export enum NetworkQuestionLeveledAchievementType {
  ANSWER_UPVOTE = "ANSWER_UPVOTE",
  BEST_ANSWER = "BEST_ANSWER",
  QUESTION_UPVOTE = "QUESTION_UPVOTE",
}

/**
 * The modes of network questions feature enablement
 */
export enum NetworkQuestionsEnablementMode {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  ENABLED_NETWORK_QUESTIONS_ONLY_MODE = "ENABLED_NETWORK_QUESTIONS_ONLY_MODE",
}

/**
 * Scope for network search
 */
export enum NetworkSearchScopeType {
  DEFAULT = "DEFAULT",
  NETWORK_QUESTIONS = "NETWORK_QUESTIONS",
}

/**
 * OfficeGroup types
 */
export enum OfficeGroupType {
  DISTRIBUTION_GROUP = "DISTRIBUTION_GROUP",
  M365_GROUP = "M365_GROUP",
  MAIL_ENABLED_SECURITY_GROUP = "MAIL_ENABLED_SECURITY_GROUP",
  OTHER = "OTHER",
  SECURITY_GROUP = "SECURITY_GROUP",
}

/**
 * The target where a thread is to be pinned.
 */
export enum PinnedThreadFeedTarget {
  BROADCAST = "BROADCAST",
  GROUP = "GROUP",
  TEAMS_MEETING = "TEAMS_MEETING",
  USER_WALL = "USER_WALL",
}

/**
 * Types of praise badges/icons shown on the UI
 */
export enum PraiseBadge {
  ACE = "ACE",
  CHECKEREDFLAG = "CHECKEREDFLAG",
  COFFEE = "COFFEE",
  DIAMOND = "DIAMOND",
  DOUBLERAINBOW = "DOUBLERAINBOW",
  GIFT = "GIFT",
  GLASSES = "GLASSES",
  GRADUATIONCAP = "GRADUATIONCAP",
  HEART = "HEART",
  LIGHTBULB = "LIGHTBULB",
  MONEY = "MONEY",
  MONOCLE = "MONOCLE",
  NINJA = "NINJA",
  PIE = "PIE",
  STAR = "STAR",
  THUMBSUP = "THUMBSUP",
  TROPHY = "TROPHY",
}

/**
 * Question types enum
 */
export enum QuestionActivityType {
  BEST_REPLIES_MARKED = "BEST_REPLIES_MARKED",
  QUESTIONS_ASKED = "QUESTIONS_ASKED",
  REPLIES_TO_QUESTION = "REPLIES_TO_QUESTION",
}

/**
 * Types of reactions to things.
 */
export enum Reaction {
  CELEBRATE = "CELEBRATE",
  LAUGH = "LAUGH",
  LIKE = "LIKE",
  LOVE = "LOVE",
  SAD = "SAD",
  THANK = "THANK",
}

/**
 * Trend in the SentimentType at the viewer leader level.
 */
export enum SentimentTrend {
  TRENDING_MIXED = "TRENDING_MIXED",
  TRENDING_NEGATIVE = "TRENDING_NEGATIVE",
  TRENDING_NEUTRAL = "TRENDING_NEUTRAL",
  TRENDING_POSITIVE = "TRENDING_POSITIVE",
}

/**
 * The type of SharePoint web link
 */
export enum SharePointWebLinkType {
  PAGE = "PAGE",
  SITE = "SITE",
}

/**
 * The storage provider used for a given file
 */
export enum StorageProvider {
  AZURE = "AZURE",
  SHAREPOINT = "SHAREPOINT",
}

/**
 * the status of stories for this network during publi preview. @deprecated(reason:
 * 'Use StoriesSettings#isStoriesEnabled after GA of stories')
 */
export enum StoriesEnabledStatus {
  DEFAULT = "DEFAULT",
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

/**
 * Target audience used to notify sets of users of a storyline announcement.
 */
export enum StorylineAnnouncementAudience {
  ALL_COMPANY = "ALL_COMPANY",
  EMPLOYEES = "EMPLOYEES",
}

/**
 * Enum for allowed notification types.
 */
export enum StorylineAnnouncementDeliveryTarget {
  EMAIL = "EMAIL",
  IN_APP = "IN_APP",
  TEAMS = "TEAMS",
}

/**
 * Target notification used to notify audience of a storyline announcement.
 */
export enum StorylineAnnouncementNotificationTarget {
  EMAIL = "EMAIL",
  IN_APP = "IN_APP",
  TEAMS = "TEAMS",
}

/**
 * Enum for allowed notification types.
 */
export enum StorylineDefaultNotificationDeliveryTarget {
  EMAIL = "EMAIL",
  IN_APP = "IN_APP",
  TEAMS = "TEAMS",
}

/**
 * Enum for allowed notification types.
 */
export enum StorylineDigestDeliveryTarget {
  EMAIL = "EMAIL",
  TEAMS = "TEAMS",
}

/**
 * The status of storyline for this network during public preview. 
 * @deprecated(reason: 'Use StorylineSettings#isStorylineEnabled after GA of storyline')
 */
export enum StorylineEnabledStatus {
  DEFAULT = "DEFAULT",
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}

/**
 * The platforms a user is subscribed to notifications on
 */
export enum SubscriptionTarget {
  ANDROID = "ANDROID",
  EMAIL = "EMAIL",
  IOS = "IOS",
}

/**
 * Suggested action surface type
 */
export enum SuggestedActionSurface {
  WEB_FIRST_RUN = "WEB_FIRST_RUN",
  WEB_LIGHTBOX = "WEB_LIGHTBOX",
  WEB_RIGHT_RAIL = "WEB_RIGHT_RAIL",
}

/**
 * Different modes for sorting suggestion results
 */
export enum SuggestionMode {
  PROXIMITY_RANK = "PROXIMITY_RANK",
}

/**
 * Enum for the type of Teams live event
 */
export enum TeamsLiveEventType {
  TEAMS_BYOE = "TEAMS_BYOE",
  TEAMS_QUICKSTART = "TEAMS_QUICKSTART",
}

/**
 * The ordering to use for the threads in a feed
 */
export enum TeamsMeetingFeedThreadSortOrder {
  CREATED_AT = "CREATED_AT",
  CREATED_OR_PUBLISHED_AT = "CREATED_OR_PUBLISHED_AT",
  UPDATED_AT = "UPDATED_AT",
  UPVOTE_RANK_THEN_CREATED_OR_PUBLISHED_AT = "UPVOTE_RANK_THEN_CREATED_OR_PUBLISHED_AT",
}

/**
 * Types of Teams meeting feeds.
 */
export enum TeamsMeetingFeedType {
  ALL = "ALL",
  MODERATION_DISMISSED = "MODERATION_DISMISSED",
  MODERATION_PENDING = "MODERATION_PENDING",
  MODERATION_PENDING_QUESTIONS = "MODERATION_PENDING_QUESTIONS",
  QUESTIONS = "QUESTIONS",
  UNANSWERED_QUESTIONS = "UNANSWERED_QUESTIONS",
  VIEWER_IS_THREAD_STARTER_SENDER = "VIEWER_IS_THREAD_STARTER_SENDER",
}

/**
 * Sort order for Teams Meetings
 */
export enum TeamsMeetingSortOrder {
  START_DATE_ASC = "START_DATE_ASC",
  START_DATE_DESC = "START_DATE_DESC",
}

/**
 * The status of the Teams meeting
 */
export enum TeamsMeetingStatus {
  CREATED = "CREATED",
  ENDED = "ENDED",
  STARTED = "STARTED",
}

/**
 * List of the subtypes and filters of feeds that can be sent, along with the
 * overall type, to telemetry endpoints or used when marking threads and messages as seen
 */
export enum TelemetryFeedSubtype {
  ACTIVITY_FEATURED_REPLIES = "ACTIVITY_FEATURED_REPLIES",
  ACTIVITY_TOP_THREADS = "ACTIVITY_TOP_THREADS",
  ALL = "ALL",
  ALL_PUBLIC_GROUPS = "ALL_PUBLIC_GROUPS",
  ANNOUNCEMENTS = "ANNOUNCEMENTS",
  DEFAULT = "DEFAULT",
  DIRECT = "DIRECT",
  DISCOVERY = "DISCOVERY",
  DRAFTS = "DRAFTS",
  FOLLOWING_AND_ALLCOMPANY = "FOLLOWING_AND_ALLCOMPANY",
  LEGACY_DISCOVERY = "LEGACY_DISCOVERY",
  MODERATION_DISMISSED = "MODERATION_DISMISSED",
  MODERATION_PENDING = "MODERATION_PENDING",
  MODERATION_PENDING_QUESTIONS = "MODERATION_PENDING_QUESTIONS",
  QUESTIONS = "QUESTIONS",
  RECOMMENDED = "RECOMMENDED",
  SEARCH_GROUP = "SEARCH_GROUP",
  SEARCH_INBOX = "SEARCH_INBOX",
  SEARCH_NETWORK = "SEARCH_NETWORK",
  THREAD_DEEP_LINK = "THREAD_DEEP_LINK",
  UNANSWERED = "UNANSWERED",
  UNANSWERED_QUESTIONS = "UNANSWERED_QUESTIONS",
  UNREAD = "UNREAD",
  UNSEEN = "UNSEEN",
  VIEWER_IS_THREAD_STARTER_SENDER = "VIEWER_IS_THREAD_STARTER_SENDER",
}

/**
 * List of the overall types of feeds that can be sent, along with subtype, to
 * telemetry endpoints or used when marking threads and messages as seen
 */
export enum TelemetryFeedType {
  ALL_COMPANY_GROUP = "ALL_COMPANY_GROUP",
  ALL_FEED = "ALL_FEED",
  ALL_STORYLINE = "ALL_STORYLINE",
  ATTACHABLE_LINK = "ATTACHABLE_LINK",
  BOOKMARK = "BOOKMARK",
  BROADCAST = "BROADCAST",
  CAMPAIGN = "CAMPAIGN",
  DISCOVERY_LEADERS = "DISCOVERY_LEADERS",
  DISCOVERY_NETWORK_QUESTION = "DISCOVERY_NETWORK_QUESTION",
  DISCOVERY_STORYLINE = "DISCOVERY_STORYLINE",
  FOLLOWED_STORYLINE = "FOLLOWED_STORYLINE",
  GROUP = "GROUP",
  HOME = "HOME",
  HOME_MOMENTS_FEED = "HOME_MOMENTS_FEED",
  INBOX = "INBOX",
  LEADER_EMPLOYEES = "LEADER_EMPLOYEES",
  LEADER_HIGHLIGHTED = "LEADER_HIGHLIGHTED",
  MY_LEADERS = "MY_LEADERS",
  NETWORK_QUESTION = "NETWORK_QUESTION",
  NETWORK_QUESTION_INBOX = "NETWORK_QUESTION_INBOX",
  SEARCH = "SEARCH",
  TEAMS_MEETING = "TEAMS_MEETING",
  THREAD = "THREAD",
  THREAD_CONTEXTUAL = "THREAD_CONTEXTUAL",
  TOPIC = "TOPIC",
  TOPIC_NETWORK_QUESTION = "TOPIC_NETWORK_QUESTION",
  UNKNOWN = "UNKNOWN",
  USER = "USER",
  USER_MOMENTS_FEED = "USER_MOMENTS_FEED",
  USER_WALL = "USER_WALL",
  WORKPLACE_FEED = "WORKPLACE_FEED",
}

/**
 * Enum for the type of thread activity action
 */
export enum ThreadActivityActionType {
  FEATURED = "FEATURED",
  PINNED = "PINNED",
  UNFEATURED = "UNFEATURED",
  UNPINNED = "UNPINNED",
}

/**
 * The level of a message in the thread it belongs to.
 */
export enum ThreadMessageLevel {
  SECOND_LEVEL_REPLY = "SECOND_LEVEL_REPLY",
  THREAD_STARTER = "THREAD_STARTER",
  TOP_LEVEL_REPLY = "TOP_LEVEL_REPLY",
}

/**
 * The ordering to use for the thread replies
 */
export enum ThreadReplySortOrder {
  CREATED_AT = "CREATED_AT",
  UPVOTE_RANK_THEN_CREATED_AT = "UPVOTE_RANK_THEN_CREATED_AT",
}

/**
 * Sort order for top campaign threads.
 */
export enum TopCampaignThreadSortOrder {
  REACTION_COUNT_DESC = "REACTION_COUNT_DESC",
  REPLY_COUNT_DESC = "REPLY_COUNT_DESC",
  VIEW_COUNT_DESC = "VIEW_COUNT_DESC",
}

/**
 * Types of curation state that a Topic can exist in.
 */
export enum TopicCurationState {
  CURATED_APPROVED = "CURATED_APPROVED",
  CURATED_PROPOSED = "CURATED_PROPOSED",
  NOT_CURATED = "NOT_CURATED",
}

/**
 * The ordering to use for the threads in a feed
 */
export enum TopicFeedThreadSortOrder {
  CREATED_AT = "CREATED_AT",
  UPDATED_AT = "UPDATED_AT",
}

/**
 * Types of topic feeds.
 */
export enum TopicFeedType {
  ALL = "ALL",
  NOT_QUESTIONS = "NOT_QUESTIONS",
  QUESTIONS = "QUESTIONS",
}

/**
 * The ordering to use for the threads in a topic network question feed
 */
export enum TopicNetworkQuestionFeedThreadSortOrder {
  CREATED_AT = "CREATED_AT",
  UPDATED_AT = "UPDATED_AT",
  UPVOTE_RANK_THEN_CREATED_AT = "UPVOTE_RANK_THEN_CREATED_AT",
}

/**
 * Types of topic network question feeds.
 */
export enum TopicNetworkQuestionFeedType {
  ALL = "ALL",
  UNANSWERED = "UNANSWERED",
  UNSEEN = "UNSEEN",
}

/**
 * Type of User Achievement admin settings.
 */
export enum UserAchievementAdminSettingsType {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
  USER_CAN_OVERRIDE = "USER_CAN_OVERRIDE",
}

/**
 * Types of admin roles that can be used to indicate the user's privileges.
 */
export enum UserAdminRoles {
  CORPORATE_COMMUNICATOR = "CORPORATE_COMMUNICATOR",
  KNOWLEDGE_MANAGER = "KNOWLEDGE_MANAGER",
  YAMMER_ADMINISTRATOR = "YAMMER_ADMINISTRATOR",
}

/**
 * The ordering to use for the threads in a feed
 */
export enum UserFeedThreadSortOrder {
  CREATED_AT = "CREATED_AT",
  UPDATED_AT = "UPDATED_AT",
}

/**
 * The ordering to use for the threads in a user moments feed.
 */
export enum UserMomentsFeedThreadSortOrder {
  CREATED_AT = "CREATED_AT",
  UPDATED_AT = "UPDATED_AT",
}

/**
 * Possible feed types for loading the moments feed.
 */
export enum UserMomentsFeedType {
  DEFAULT = "DEFAULT",
  RECENT = "RECENT",
}

/**
 * A user's accent color used to customize how reactions are rendered.
 */
export enum UserReactionAccentColor {
  FITZPATRICK_SCALE_DARK = "FITZPATRICK_SCALE_DARK",
  FITZPATRICK_SCALE_LIGHT = "FITZPATRICK_SCALE_LIGHT",
  FITZPATRICK_SCALE_MEDIUM = "FITZPATRICK_SCALE_MEDIUM",
  FITZPATRICK_SCALE_MEDIUM_DARK = "FITZPATRICK_SCALE_MEDIUM_DARK",
  FITZPATRICK_SCALE_MEDIUM_LIGHT = "FITZPATRICK_SCALE_MEDIUM_LIGHT",
  NONE = "NONE",
}

/**
 * Enum for allowed Notification type that user can subscibe to.
 */
export enum UserSubscriptionNotificationTarget {
  DEVICE_PUSH = "DEVICE_PUSH",
  EMAIL = "EMAIL",
  IN_APP = "IN_APP",
  TEAMS = "TEAMS",
}

/**
 * The ordering to use for the threads in a user wall feed
 */
export enum UserWallFeedThreadSortOrder {
  CREATED_AT = "CREATED_AT",
  UPDATED_AT = "UPDATED_AT",
}

/**
 * The status of video transcoding.
 */
export enum VideoTranscodingStatus {
  FAILED = "FAILED",
  STARTED = "STARTED",
  SUCCEEDED = "SUCCEEDED",
}

/**
 * Types of metrics based on the activity of the viewer.
 */
export enum ViewerActivityActionType {
  VIEWER_ACTIVE_CONNECTIONS_FORMED = "VIEWER_ACTIVE_CONNECTIONS_FORMED",
  VIEWER_AVERAGE_REPLIES_PER_THREAD_STARTER = "VIEWER_AVERAGE_REPLIES_PER_THREAD_STARTER",
  VIEWER_ENGAGED_FOLLOWERS_PERCENTAGE = "VIEWER_ENGAGED_FOLLOWERS_PERCENTAGE",
  VIEWER_ENGAGED_THREAD_VIEWERS_PERCENTAGE = "VIEWER_ENGAGED_THREAD_VIEWERS_PERCENTAGE",
  VIEWER_GROUP_THREAD_PERCENTAGE = "VIEWER_GROUP_THREAD_PERCENTAGE",
  VIEWER_PASSIVE_CONNECTIONS_FORMED = "VIEWER_PASSIVE_CONNECTIONS_FORMED",
  VIEWER_STORYLINE_THREAD_PERCENTAGE = "VIEWER_STORYLINE_THREAD_PERCENTAGE",
  VIEWER_TOTAL_CELEBRATE_REACTIONS = "VIEWER_TOTAL_CELEBRATE_REACTIONS",
  VIEWER_TOTAL_FOLLOWERS = "VIEWER_TOTAL_FOLLOWERS",
  VIEWER_TOTAL_FOLLOWING = "VIEWER_TOTAL_FOLLOWING",
  VIEWER_TOTAL_LAUGH_REACTIONS = "VIEWER_TOTAL_LAUGH_REACTIONS",
  VIEWER_TOTAL_LIKE_REACTIONS = "VIEWER_TOTAL_LIKE_REACTIONS",
  VIEWER_TOTAL_LOVE_REACTIONS = "VIEWER_TOTAL_LOVE_REACTIONS",
  VIEWER_TOTAL_REACTIONS = "VIEWER_TOTAL_REACTIONS",
  VIEWER_TOTAL_REPLIES_ON_VIEWER_THREAD_STARTERS = "VIEWER_TOTAL_REPLIES_ON_VIEWER_THREAD_STARTERS",
  VIEWER_TOTAL_SAD_REACTIONS = "VIEWER_TOTAL_SAD_REACTIONS",
  VIEWER_TOTAL_THANK_REACTIONS = "VIEWER_TOTAL_THANK_REACTIONS",
  VIEWER_TOTAL_THREAD_STARTER_VIEWERS = "VIEWER_TOTAL_THREAD_STARTER_VIEWERS",
  VIEWER_TOTAL_USERS_REPLIED_TO = "VIEWER_TOTAL_USERS_REPLIED_TO",
}

/**
 * Thread type categories for the personal level viewer insights dashboard.
 */
export enum ViewerActivityThreadType {
  ALL = "ALL",
  STORIES_AND_STORYLINE = "STORIES_AND_STORYLINE",
}

/**
 * Time type categories for viewer activity.
 */
export enum ViewerActivityTimeframeType {
  NINETY_DAYS = "NINETY_DAYS",
  SEVEN_DAYS = "SEVEN_DAYS",
  TWELVE_MONTHS = "TWELVE_MONTHS",
  TWENTY_EIGHT_DAYS = "TWENTY_EIGHT_DAYS",
}

/**
 * Type of permission and reason viewer can or cannot access user achievements.
 */
export enum ViewerCanAccessUserAchievementsResultType {
  ALLOWED = "ALLOWED",
  MISSING_LICENSE = "MISSING_LICENSE",
  NOT_ALLOWED_BY_ADMIN_SETTING = "NOT_ALLOWED_BY_ADMIN_SETTING",
  NOT_ALLOWED_BY_USER_SETTING = "NOT_ALLOWED_BY_USER_SETTING",
}

/**
 * Viewer top thread collection type.
 */
export enum ViewerTopThreadType {
  VIEWER_MOST_REACTED_THREADS = "VIEWER_MOST_REACTED_THREADS",
  VIEWER_MOST_REPLIED_THREADS = "VIEWER_MOST_REPLIED_THREADS",
  VIEWER_MOST_VIEWED_THREADS = "VIEWER_MOST_VIEWED_THREADS",
}

/**
 * Web client preferences.
 */
export enum WebClientPreference {
  LEGACY = "LEGACY",
  MODERN = "MODERN",
  NONE = "NONE",
}

/**
 * Supported providers of video.
 */
export enum WebVideoProvider {
  O365 = "O365",
  STREAMS = "STREAMS",
  VIMEO = "VIMEO",
  YOUTUBE = "YOUTUBE",
}

/**
 * The input required to add a pinned object to campaign relationship
 */
export interface AddCampaignPinnedObjectLinkInput {
  campaignId: string;
  overridePinnedLinkTitle?: string | null;
  pinnedObjectLink: GraphQlURI;
}

/**
 * The input required to add a pinned object to campaign relationship
 */
export interface AddCampaignPinnedObjectRelationshipInput {
  campaignId: string;
  overridePinnedLinkTitle?: string | null;
  pinnedObjectId: string;
}

/**
 * The input required to mark a group as favorite for a user
 */
export interface AddFavoriteGroupInput {
  groupId: string;
}

/**
 * The input required to add a pinned object to group relationship
 */
export interface AddPinnedObjectRelationshipInput {
  groupId: string;
  pinnedObjectId: string;
}

/**
 * The input required to add a topic to a thread
 */
export interface AddThreadTopicInput {
  displayName?: string | null;
  threadMutationId: string;
  topicId?: string | null;
}

/**
 * The input required to add a thread upvote
 */
export interface AddThreadUpvoteInput {
  threadId: string;
}

/**
 * The input required to add a user delegate.
 */
export interface AddUserDelegateInput {
  delegateRole: DelegateRole;
  delegateUserId: string;
  onBehalfOfUserId: string;
}

/**
 * The input required to create a new Yammer campaign goal tracker.
 */
export interface CreateCampaignGoalTrackerInput {
  campaignId: string;
  currencyUnit?: GraphQlCurrency | null;
  customUnit?: string | null;
  targetValue: number;
  timeUnit?: CampaignGoalTrackerTimeUnitType | null;
  type: CampaignGoalTrackerType;
}

/**
 * The input required to create a new Yammer campaign.
 */
export interface CreateCampaignInput {
  color?: CampaignColor | null;
  description?: string | null;
  displayName: string;
  hashTags: string[];
  threadStarterDefaultContentType?: CampaignDefaultThreadStarterContentType | null;
}

/**
 * The input required to delete a Yammer campaign.
 */
export interface DeleteCampaignInput {
  campaignId: string;
}

/**
 * The input required to enable or disable analytics features.
 */
export interface EditAnalyticsSettingsInput {
  isOverallSentimentInLeadershipActivityEnabled?: boolean | null;
  isSentimentPerTopThemeInLeadershipActivityEnabled?: boolean | null;
  isSentimentPerTopThreadInLeadershipActivityEnabled?: boolean | null;
  isTimeSavedAndPeopleHelpedInNetworkQuestionActivityEnabled?: boolean | null;
  isTopThreadStarterSendersInCampaignActivityEnabled?: boolean | null;
}

/**
 * The input required to edit a campaign goal tracker
 */
export interface EditCampaignGoalTrackerInput {
  campaignId: string;
  currencyUnit?: GraphQlCurrency | null;
  currentValue?: number | null;
  customUnit?: string | null;
  targetValue?: number | null;
  timeUnit?: CampaignGoalTrackerTimeUnitType | null;
  type?: CampaignGoalTrackerType | null;
}

/**
 * The input required to edit a campaign
 */
export interface EditCampaignInput {
  campaignId: string;
  color?: CampaignColor | null;
  description?: string | null;
  displayName?: string | null;
  executiveSponsorUserIds?: string[] | null;
  hashTags?: string[] | null;
  state?: CampaignState | null;
  threadStarterDefaultContentType?: CampaignDefaultThreadStarterContentType | null;
}

/**
 * The input required to edit leader settings for this network
 */
export interface EditLeaderSettingsInput {
  isLeadershipCornerEnabled?: boolean | null;
}

/**
 * The additional input required to edit a praise in a message.
 */
export interface EditMessagePraiseInput {
  badge: PraiseBadge;
  userIds: string[];
}

/**
 * The input required to edit network questions settings for this network
 */
export interface EditNetworkQuestionsSettingsInput {
  infoPanelBody?: string | null;
  infoPanelLinkText?: string | null;
  infoPanelLinkUri?: GraphQlURI | null;
  infoPanelTitle?: string | null;
  networkQuestionsEnablementMode?: NetworkQuestionsEnablementMode | null;
}

/**
 * The input required to edit stories settings for this network
 */
export interface EditStoriesSettingsInput {
  isStoriesEnabled?: boolean | null;
  storiesEnabledStatus?: StoriesEnabledStatus | null;
}

/**
 * The input required to edit storyline settings for this network
 */
export interface EditStorylineSettingsInput {
  isPremiumStorylinePreviewEnabled?: boolean | null;
  isStorylineEnabled?: boolean | null;
  isStorylineOnlyForUsersInOfficeGroupEnabled?: boolean | null;
  storylineEnabledStatus?: StorylineEnabledStatus | null;
  storylineOnlyForUsersInOfficeGroupId?: string | null;
}

/**
 * The input required to grant post-on-behalf-of storyline permission to a user delegate.
 */
export interface EditUserDelegateInput {
  canPostToStoryline?: boolean | null;
  delegateRole?: DelegateRole | null;
  delegateUserId: string;
  onBehalfOfUserId: string;
}

/**
 * A set of telemetry context values for a feed type and id used as input when marking threads and messages as seen
 */
export interface FeedThreadTelemetryContextInput {
  subtype: TelemetryFeedSubtype;
  telemetryId?: string | null;
  type: TelemetryFeedType;
}

/**
 * The input required to follow a campaign.
 */
export interface FollowCampaignInput {
  campaignId: string;
}

/**
 * The input required to mark a group message as seen
 */
export interface MarkMessageOfThreadAsSeenInput {
  messageMutationId: string;
  threadMutationId: string;
}

/**
 * The input required to mark a thread as seen
 */
export interface MarkThreadAsSeenInput {
  latestMessageId?: string | null;
  threadMarkSeenKey: string;
}

/**
 * The input required to unmark a group as favorite for a user
 */
export interface RemoveFavoriteGroupInput {
  groupId: string;
}

/**
 * The input required to remove a participnat from a thread.
 */
export interface RemoveParticipantsInput {
  participantIds: string[];
  threadMutationId: string;
}

/**
 * The input required to remove a topic from a thread
 */
export interface RemoveThreadTopicInput {
  threadMutationId: string;
  topicId: string;
}

/**
 * The input required to remove a thread upvote.
 */
export interface RemoveThreadUpvoteInput {
  threadId: string;
}

/**
 * The input required to remove a user delegate.
 */
export interface RemoveUserDelegateInput {
  delegateUserId: string;
  onBehalfOfUserId: string;
}

/**
 * The input required to create a notification subscription for user being followed.
 */
export interface SubscribeToFollowedUserNotificationsInput {
  followedUserId: string;
  targets: UserSubscriptionNotificationTarget[];
}

/**
 * The input context for the suggested action
 */
export interface SuggestedActionContextInput {
  contextIds?: string[] | null;
  feedSubtype?: TelemetryFeedSubtype | null;
  feedType?: TelemetryFeedType | null;
}

/**
 * The input required to stop following a campaign.
 */
export interface UnfollowCampaignInput {
  campaignId: string;
}

/**
 * The input required to remove a notification subscription for user being followed.
 */
export interface UnsubscribeToFollowedUserNotificationsInput {
  followedUserId: string;
  targets: UserSubscriptionNotificationTarget[];
}

/**
 * The input required to update app activity state.
 */
export interface UpdateAppActivityStateInput {
  appActivityState: AppActivityState;
}

/**
 * The input required to update broadcast activity state.
 */
export interface UpdateBroadcastActivityStateInput {
  broadcastActivityState: BroadcastActivityState;
  broadcastId: string;
}

/**
 * The input required to update storyline default notification settings for the network.
 */
export interface UpdateStorylineDefaultNotificationDeliverySettingsInput {
  targets?: StorylineDefaultNotificationDeliveryTarget[] | null;
}

/**
 * Input to update user admin roles
 */
export interface UpdateUserAdminRolesInput {
  userAdminRolesToBeAdded: UserAdminRoles[];
  userAdminRolesToBeRemoved: UserAdminRoles[];
  userId: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
